import React, { useEffect } from 'react';
import CourseActions from '../../redux/actions/CourseActions';
import FooterNavigation from '../FooterNavigation/FooterNavigation';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import AppHeader from '../../components/AppHeader/AppHeader';
import SideNav from '../../components/SideNav/SideNav';
import CourseIndex from '../../components/CourseIndex/CourseIndex';
import RecentlyViewed from '../../components/RecentlyViewed/RecentlyViewed';
import Bookmarks from '../../components/Bookmarks/Bookmarks';
import Search from '../../components/Search/Search';
import IframeModal from '../../components/Iframe/Iframe';
import Language from '../../components/Language/Language';
import Loader from '../Block/common/Loading/Loading';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import Block from '../Block/Block';
import smoothscroll from 'smoothscroll-polyfill';
import { ElementQueries } from 'css-element-queries';
import 'highlight.js/styles/monokai-sublime.css';
import './AppLayout.scss'; // make sure this loads after any 3rd party css

smoothscroll.polyfill();
// moves modals in to their own component
// TODO:
// - move code in to its own component in the file system
// - refactor and generalize modal's code for re-use
const Modals = () => {
  // get visible states
  const {
    isRecentlyViewedVisible,
    isBookmarksVisible,
    isCourseIndexVisible,
    isSearchVisible,
    isIframeModalVisible,
    isLanguageVisible
  } = useSelector(
    state => ({
      isRecentlyViewedVisible: state.RecentViewsState.isRecentlyViewedVisible,
      isBookmarksVisible: state.BookmarksState.isBookmarksVisible,
      isCourseIndexVisible: state.CourseIndexState.isCourseIndexVisible,
      isSearchVisible: state.SearchState.isSearchVisible,
      isIframeModalVisible: state.IframeModalState.isIframeModalVisible,
      isLanguageVisible: state.LanguageState.isLanguageVisible
    }),
    shallowEqual
  );
  // show 'em if ya got 'em
  return (
    <>
      {isRecentlyViewedVisible && <RecentlyViewed />}
      {isBookmarksVisible && <Bookmarks />}
      {isCourseIndexVisible && <CourseIndex />}
      {isSearchVisible && <Search />}
      {isIframeModalVisible && <IframeModal />}
      {isLanguageVisible && <Language />}
    </>
  );
};

// primary appllication layout
const AppLayout = () => {
  const dispatch = useDispatch();
  const [currentElement, setElement] = React.useState(null);
  document.addEventListener('fullscreenchange', function () {
    if (document.webkitIsFullScreen) {
      setElement(document.webkitFullscreenElement);
    } else if (currentElement !== null) {
      currentElement.scrollIntoView();
    }
  });
  // get nav visible state, and course loaded state
  const { isNavVisible, loading } = useSelector(
    state => ({
      isNavVisible: state.SideNavState.isNavVisible,
      loading: state.CourseState.loading
    }),
    shallowEqual
  );

  // initialize the course in first run
  useEffect(() => {
    dispatch(CourseActions.initCourse());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    ElementQueries.init();
  }, []);

  // if the course isn't loaded, display the loader
  if (loading) {
    return <Loader context="AppLayout" />;
  }

  return (
    <>
      <Modals />
      <AppHeader />
      <SideNav />

      <div className={`main-content-wrapper ${isNavVisible && 'nav-visible'}`}>
        <Breadcrumb />
        <main className="main-content">
          {!loading && (
            <article>
              <div className="layout-wrapper">
                <Block />
              </div>
              <FooterNavigation />
            </article>
          )}
        </main>
      </div>
    </>
  );
};

export default AppLayout;
